import React, { createContext, useState, useEffect } from 'react';

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [models, setModels] = useState([]);
  const [modelData, setModelData] = useState([]);
  const [serviceData, setServiceData] = useState(null);

  useEffect(() => {
    // Load models from backend or define them here
    const fetchModels = async () => {
      // Fetch models from backend API if needed, else define statically
      const modelsList = ['dolphin', 'sealion_7', 'tang', 'seal_u'];
      setModels(modelsList);
    };

    fetchModels();
  }, []);

  useEffect(() => {
    const loadModelData = async () => {
      const dataPromises = models.map(async (model) => {
        try {
          const module = await import(`../data/${model}.json`);
          return module.default;
        } catch (error) {
          console.error(`Error loading data for model ${model}:`, error);
          return null;
        }
      });
      const data = await Promise.all(dataPromises);
      setModelData(data.filter(item => item !== null));
    };

    if (models.length > 0) {
      loadModelData();
    }
  }, [models]);

  const loadServiceData = async (id) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SOCKET_SERVER_URL}/get_customer_info?relation_id=${id}`);
      const data = await response.json();
      setServiceData(data);
    } catch (error) {
      console.error(`Error fetching service data for ID ${id}:`, error);
      setServiceData(null);
    }
  };

  return (
    <DataContext.Provider value={{ models, modelData, serviceData, loadServiceData }}>
      {children}
    </DataContext.Provider>
  );
};